// extracted by mini-css-extract-plugin
module.exports = {"preview":"preview_preview__3lr-V","imagebox":"preview_imagebox__DVgBa","editbutton":"preview_editbutton__1H5ey","actions":"preview_actions__3-Joz"};